import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/money-flow/funding/layout.tsx");
